<ziro-top-nav></ziro-top-nav>
<div class="col-md-8 offset-md-2 mt-2">
  <h1>
    <ziro-stacked-icon
      [stackedIcon]="ZiroStackedIcons[ziroIcons.PIN_RESET]"
      parentClass="fa-stack fa-md"
    ></ziro-stacked-icon>
    <span>{{ 'tkey;pages.pinreset.title' | translate }}</span>
  </h1>

  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

  <div class="row mt-2" [hidden]="isLoading">
    <legend data-automation="pin-reset-user-display-name">
      {{ voicemail?.displayName }}
    </legend>

    <ziro-pin-reset #vmPin [fieldId]="'vmPinReset'" (resetClicked)="onSubmit()"></ziro-pin-reset>
  </div>
</div>
